import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import useTheme from '@common/hooks/useTheme'

const PrivacyIcon: React.FC<SvgProps> = ({ width = 26, height = 26, color }) => {
  const { theme } = useTheme()
  // Honor an explicit `color` (the settings menu tints it like its siblings);
  // fall back to the grey icon color so existing call sites stay unchanged.
  const fill = color ?? theme.iconSecondary

  return (
    <Svg width={width} height={height} viewBox="0 0 26 26">
      <Path
        fill="none"
        strokeLinecap="round"
        d="M12.671 24.901a18.137 18.137 0 0 1-6.8-3.9 12.109 12.109 0 0 1-2.586-3.371 9.421 9.421 0 0 1-1.026-4.27V4.301c.5.041.81.066 1.3.066a14.2 14.2 0 0 0 4.312-.641A23.474 23.474 0 0 0 13 1a23.5 23.5 0 0 0 5.127 2.726 14.2 14.2 0 0 0 4.312.641c.493 0 .8-.024 1.3-.065v9.058a9.421 9.421 0 0 1-1.026 4.27 12.109 12.109 0 0 1-2.583 3.375 18.138 18.138 0 0 1-6.816 3.9l-.316.1Z"
      />
      <Path
        strokeLinecap="round"
        d="M13 22.906c2.142-.71 4.23-1.925 5.766-3.362.936-.875 1.663-1.821 2.163-2.813a7.44 7.44 0 0 0 .812-3.371V6.352c-1.096-.044-2.696-.208-4.25-.73-1.675-.562-3.374-1.528-4.489-2.228-1.097.687-2.813 1.664-4.492 2.228-1.555.522-3.155.686-4.251.73v7.008c0 1.165.273 2.3.813 3.37.5.993 1.227 1.94 2.162 2.814C8.77 20.981 10.86 22.196 13 22.906M13 25l-.329-.1c-2.515-.782-4.984-2.194-6.803-3.895-1.108-1.036-1.977-2.172-2.583-3.375a9.421 9.421 0 0 1-1.026-4.27V4.301c.503.041.81.066 1.303.066.897 0 2.651-.084 4.312-.641C10.348 2.895 13 1 13 1s2.656 1.896 5.127 2.726c1.66.557 3.414.64 4.312.64.493 0 .8-.024 1.302-.064v9.058c0 1.48-.345 2.917-1.026 4.27-.605 1.203-1.474 2.339-2.583 3.375-1.821 1.703-4.296 3.118-6.816 3.9L13 25Z"
        fill={fill}
      />
      <Path
        d="M13 10.014a2.918 2.918 0 0 1 2.813 3.817l1.808 1.808a6.974 6.974 0 0 0 1.879-2.676 7 7 0 0 0-8.651-4.089l1.282 1.282a3.037 3.037 0 0 1 .869-.142ZM7.51 8.04a.588.588 0 0 0 0 .833l1.165 1.165A7.027 7.027 0 0 0 6.5 12.969a6.972 6.972 0 0 0 9.047 3.947l1.607 1.607a.589.589 0 0 0 .833-.833L8.35 8.04a.6.6 0 0 0-.84 0ZM13 15.923a2.956 2.956 0 0 1-2.955-2.954 2.9 2.9 0 0 1 .29-1.269l.928.928a2.029 2.029 0 0 0-.035.337A1.77 1.77 0 0 0 13 14.741a1.592 1.592 0 0 0 .337-.041l.928.928a2.844 2.844 0 0 1-1.265.295Zm1.755-3.15a1.754 1.754 0 0 0-1.56-1.56Z"
        fill={fill}
        fillRule="evenodd"
      />
    </Svg>
  )
}

export default PrivacyIcon
